import { Button } from './BaseButton/index';
import { BaseIcon } from './BaseIcon/index';
import { BaseInput } from './BaseInput/index';
import { BasePageHeader } from './BasePageHeader/index';
import { BaseEmpty } from './BaseEmpty/index';
import { BaseBackTop } from './BaseBackTop/index';
import { BaseSelect } from './BaseSelect/index';
import { BasePopup } from './BasePopup/index';
import { BaseRadio } from './BaseRadio/index';
import { BaseCascader } from './BaseCascader/index';

import { BaseStep, BaseStepItem } from './BaseStep/index';
import { App } from 'vue';

const compList = [
  Button,
  BaseIcon,
  BaseInput,
  BasePageHeader,
  BaseStep,
  BaseStepItem,
  BaseEmpty,
  BaseBackTop,
  BaseSelect,
  BasePopup,
  BaseRadio,
  BaseCascader,
];
import './base.scss';
export function registerGlobComp(app: App) {
  compList.forEach((comp) => {
    app.component(comp.name, comp);
  });
}
